import { render, staticRenderFns } from "./rfq-number.vue?vue&type=template&id=6aba9104&"
import script from "./rfq-number.vue?vue&type=script&lang=js&"
export * from "./rfq-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports